import { PropsWithChildren, ReactElement } from "react";
import classNames from "classnames";
import { Icon } from "assets/icons";

import styles from "./styles.module.scss";

type AccordionProps = {
  collapsed: boolean;
  parent: ReactElement | null;
  handleCollapse?: () => void;
  className?: string;
  childrenClassName?: string;
  iconClassNames?: string;
  withIcon?: boolean;
  disabled?: boolean;
};

export const Accordion = (
  props: PropsWithChildren<AccordionProps>
): JSX.Element => {
  const {
    iconClassNames = "",
    handleCollapse,
    parent,
    collapsed,
    children,
    withIcon,
    childrenClassName,
    disabled,
  } = props;

  return (
    <>
      <div
        className={classNames(
          "relative",
          { [styles.disabled]: disabled },
          props.className
        )}
        onClick={disabled ? () => {} : handleCollapse}
      >
        {withIcon && (
          <div className="absolute right-1 top-2.5 cursor-pointer">
            {collapsed ? (
              <Icon
                type="arrow"
                className={`rotate-90 transition-transform ${iconClassNames}`}
              />
            ) : (
              <Icon
                type="arrow"
                className={`rotate-180 transition-transform ${iconClassNames}`}
              />
            )}
          </div>
        )}
        <div>{parent}</div>
      </div>
      <div
        className={classNames(
          {
            [styles.collapsed]: collapsed,
            [styles.expanded]: true,
          } as any,
          styles.accordion,
          childrenClassName as any
        )}
      >
        {children}
      </div>
    </>
  );
};
